import CopyCode from "components/design/copyCode";
import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { BareInput, Label } from "components/DesignSystem/TextInput/TextInput";
import { COPIED_TEXT, FAILED_COPIED_TEXT } from "constants/documents";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import { useGetFolderContentQuery } from "store/apis/documents";
import { ModalProps } from "types/utils/modal";
import CopyIcon from "static/images/CopyPurple.svg";

export const SavedToInkleDocsModal = ({
  fileId,
  reportType,
  ...props
}: ModalProps & { fileId: string; reportType: string }) => {
  const groupId = useCurrentGroupContext().uuid;
  const { data } = useGetFolderContentQuery({
    groupId: groupId,
    folderId: fileId,
  });

  const { successToast, alertToast } = useToast();

  const link = `${window.location.origin}/file-preview/${groupId}/${fileId}`;

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(link);
      successToast({ message: COPIED_TEXT });
    } catch (err) {
      alertToast({ message: FAILED_COPIED_TEXT });
    }
  };

  return (
    <Modal.Root open={props.isOpen} onOpenChange={props.close}>
      <Modal.Content size="small">
        <StatusModal type="success" title={`${reportType} saved to Inkle Docs`}>
          <p className="t-mb-5 t-text-text-30">
            You can find the saved documents under
            <br />
            Documents {">"}{" "}
            {data?.parents_list.map((parent, index, list) => (
              <span key={parent.uuid} className="t-inline-block t-mr-1">
                {parent.name} {index < list.length - 1 && " > "}
              </span>
            ))}
          </p>
          <span className="t-text-body-sm t-text-text-30">Copy link</span>
          <div
            onClick={copyToClipBoard}
            className="t-bg-white t-h-9 t-border t-border-solid t-border-surface-grey t-rounded t-mt-2 t-flex t-justify-between t-px-3 t-items-center t-shadow-light-30 t-cursor-pointer"
          >
            <div className="t-text-body-sm t-text-text-60 t-line-clamp-1">
              {link}
            </div>
            <Button customType="ghost_icon" size="xsmall">
              <img className="t-h-4 t-w-4" src={CopyIcon} alt="copyIcon" />
            </Button>
          </div>
        </StatusModal>
      </Modal.Content>
    </Modal.Root>
  );
};
